import { render } from "./AppOption.vue?vue&type=template&id=63d361e7&scoped=true&ts=true"
import script from "./AppOption.vue?vue&type=script&lang=ts"
export * from "./AppOption.vue?vue&type=script&lang=ts"

import "./AppOption.vue?vue&type=style&index=0&id=63d361e7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d361e7"]])

export default __exports__